import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';

import type { ITilesLayoutDepsDesktop, TTilesLayoutDesktop } from '../../models';
import { TileDesktop as Tile } from '../tile/desktop';

import styles from './styles/tiles-layout.css';
import { TilesLayoutComponent as Component } from './layout';

export const TilesLayoutDesktop = createWidget<ITilesLayoutDepsDesktop, TTilesLayoutDesktop>({
    Block,
    Grid,
    Tile,
    styles,
})(Component);
